import styled from "@emotion/styled";

import { fontFredoka, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { AppFooter } from "scmp-app/components/app-footer";
import { ContentItemPostiesSectionPrimary } from "scmp-app/components/content/content-item-render/variants/posties-section-primary";
import { ContentItemPostiesSectionSecondary } from "scmp-app/components/content/content-item-render/variants/posties-section-secondary";

import LineSvg from "./line.svg";
import TopBgQuiz from "./top-bg-quiz.png";
import TopBg from "./top-bg.png";
import WelcomeMessageLargeDesktopQuiz_ from "./welcome-msg-large-desktop-quiz.png";
import WelcomeMessageLargeDesktop_ from "./welcome-msg-large-desktop.png";
import WelcomeMessageQuiz_ from "./welcome-msg-quiz.png";
import WelcomeMessage_ from "./welcome-msg.png";

type ContainerProps = {
  $isQuizSection?: boolean;
};
export const Container = styled.div<ContainerProps>`
  ${setFullViewportWidthStyles()}
  padding-block-start: 48px;

  background-image: url(${TopBg.src});
  background-repeat: no-repeat;
  background-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    padding-block-start: 64px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    padding-block-start: 72px;
  }

  ${props =>
    props.$isQuizSection &&
    `
    background-image: url(${TopBgQuiz.src});
  `}
`;

type HeadlineProps = {
  $isQuizSection?: boolean;
};
export const Headline = styled.h1<HeadlineProps>`
  max-inline-size: 292px;
  margin-block: 0;
  margin-block-end: 32px;
  margin-inline: auto;

  color: #0f75bf;
  font-weight: 400;
  font-size: 32px;
  font-family: Angkor;
  font-style: normal;
  line-height: 36px;
  letter-spacing: -0.64px;
  text-align: center;
  text-transform: uppercase;
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 508px;

    font-size: 48px;
    line-height: 56px;
    letter-spacing: -0.96px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    margin-block-end: 66px;
  }
`;

type WelcomeMessageProps = {
  $isQuizSection?: boolean;
};
export const WelcomeMessage = styled.div<WelcomeMessageProps>`
  inline-size: 279.2px;
  block-size: 140px;
  margin-block: 0;
  margin-block-end: -1px;
  margin-inline: auto;

  background-image: url(${props =>
    props.$isQuizSection ? WelcomeMessageQuiz_.src : WelcomeMessage_.src});
  background-repeat: no-repeat;
  background-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 349px;
    block-size: 175px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    display: none;
  }
`;

type WelcomeMessageLargeDesktopProps = {
  $isQuizSection?: boolean;
};
export const WelcomeMessageLargeDesktop = styled.div<WelcomeMessageLargeDesktopProps>`
  display: none;

  ${theme.breakpoints.up("largeDesktop")} {
    position: absolute;
    inset-block-start: ${props => (props.$isQuizSection ? "139px" : "96px")};
    inset-inline-start: 34px;

    display: block;

    inline-size: ${props => (props.$isQuizSection ? "241px" : "207px")};
    block-size: ${props => (props.$isQuizSection ? "448px" : "469px")};

    background-image: url(${props =>
      props.$isQuizSection
        ? WelcomeMessageLargeDesktopQuiz_.src
        : WelcomeMessageLargeDesktop_.src});
    background-repeat: no-repeat;
    background-size: 100%;
  }
`;

export const StyledContentItemPostiesSectionPrimary = styled(ContentItemPostiesSectionPrimary)`
  display: block;

  margin-block-end: 32px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 48px;
  }
`;

export const StyledContentItemPostiesSectionSecondary = styled(ContentItemPostiesSectionSecondary)`
  display: block;

  margin-block: 32px;

  ${theme.breakpoints.up("tablet")} {
    margin-block: 48px;
  }
`;

export const Line = styled(LineSvg)`
  display: block;

  inline-size: 100%;
  block-size: auto;
  margin-block: 32px;

  ${theme.breakpoints.up("tablet")} {
    margin-block: 48px;
  }
`;

export const Content = styled.div`
  margin-block-end: 77px;
  padding-block: 0;
  padding-inline: 25px;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 60px;
    padding-block: 0;
    padding-inline: 93px;
  }
  ${theme.breakpoints.up("desktop")} {
    padding-block: 0;
    padding-inline: 116px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 860px;
    margin-block: 0;
    margin-inline: auto;
    padding-inline: 0;
  }
`;

export const StyledLoading = styled.div`
  margin-block: 32px;

  color: #999999;
  font-weight: 600;
  font-size: 24px;
  font-family: ${fontFredoka};
  line-height: 38px;
  text-align: center;
`;

export const StyledAppFooter = styled(AppFooter)``;
